import { create } from 'zustand';
import { Cid } from '../interfaces/exam';

export interface ExamStore {
  generalExamIcd: Cid | null;
  setGeneralExamIcd: (value: Cid | null) => void;
  generalExamObservation: string;
  setGeneralExamObservation: (value: string) => void;
  defaultExamIndex: number;
  setDefaultExamIndex: (value: number) => void;
  setExamIcdHasError: (value: boolean) => void;
  examIcdHasError: boolean;
  setExamObservationError: (value: boolean) => void;
  examObservationError: boolean;
}

export const useExamStore = create<ExamStore>()((set, get) => ({
  examObservationError: false,
  setExamObservationError(value: boolean) {
    set((prev) => {
      return {
        ...prev,
        examObservationError: value,
      };
    });
  },
  examIcdHasError: false,
  setExamIcdHasError(value: boolean) {
    set((prev) => {
      return {
        ...prev,
        examIcdHasError: value,
      };
    });
  },
  generalExamIcd: null,
  setGeneralExamIcd(value) {
    set((prev) => {
      return {
        ...prev,
        generalExamIcd: value,
      };
    });
  },
  generalExamObservation: '',
  setGeneralExamObservation(value) {
    set((prev) => {
      return {
        ...prev,
        generalExamObservation: value,
      };
    });
  },
  defaultExamIndex: 0,
  setDefaultExamIndex(value) {
    set((prev) => {
      return {
        ...prev,
        defaultExamIndex: value,
      };
    });
  },
}));
